export enum TransactionType {
  External = 0,
  International = 1, // Regular transaction (via orders/scarlett)
  AchDomestic = 2, // ACH from USA to USA

  OriginatedACHTransaction = 1300,
  ReceivedACHTransaction = 1400,
  ReturnedACHTransaction = 1500,
  ReturnedReceivedACHTransaction = 1600,
  BookTransaction = 1700,
  PurchaseTransaction = 1800,
  ATMTransaction = 1900,
  FeeTransaction = 2000,
  CardReversalTransaction = 2100,
  CardTransaction = 2200,
  WireTransaction = 2300,
  ReleaseTransaction = 2400,
  AdjustmentTransaction = 2500,
  InterestTransaction = 2600,
  DisputeTransaction = 2700,
}

// tslint:disable-next-line:no-namespace
export namespace TransactionType {
  export function toString(type: TransactionType): string {
    switch (type) {
      case TransactionType.External:
        return 'External';
      case TransactionType.International:
        return 'International';
      case TransactionType.AchDomestic:
        return 'AchDomestic';
      case TransactionType.OriginatedACHTransaction:
        return 'Originated Ach';
      case TransactionType.ReceivedACHTransaction:
        return 'Received Ach';
      case TransactionType.ReturnedACHTransaction:
        return 'Returned Ach';
      case TransactionType.ReturnedReceivedACHTransaction:
        return 'Returned Received Ach';
      case TransactionType.BookTransaction:
        return 'Book';
      case TransactionType.PurchaseTransaction:
        return 'Purchase';
      case TransactionType.ATMTransaction:
        return 'ATM';
      case TransactionType.FeeTransaction:
        return 'Fee';
      case TransactionType.WireTransaction:
        return 'Wire';
      case TransactionType.CardReversalTransaction:
        return 'Card Reversal';
      case TransactionType.CardTransaction:
        return 'Card';
      case TransactionType.ReleaseTransaction:
        return 'Release';
      case TransactionType.AdjustmentTransaction:
        return 'Adjustment';
      case TransactionType.InterestTransaction:
        return 'Interest';
      case TransactionType.DisputeTransaction:
        return 'Dispute';
      default:
        return 'Other';
    }
  }

  export function parse(transactionTypeStr: string): TransactionType {
    return TransactionType[transactionTypeStr];
  }

  export function achOrWireTxt(type: TransactionType): string {
    switch (type) {
      case TransactionType.AchDomestic:
      case TransactionType.OriginatedACHTransaction:
      case TransactionType.ReceivedACHTransaction:
      case TransactionType.ReturnedACHTransaction:
      case TransactionType.ReturnedReceivedACHTransaction:
        return 'ACH';
      case TransactionType.WireTransaction:
        return 'Wire';
      case TransactionType.CardReversalTransaction:
      case TransactionType.CardTransaction:
        return 'Card';
      case TransactionType.BookTransaction:
        return 'Internal';
      case TransactionType.ATMTransaction:
        return 'ATM';
      case TransactionType.FeeTransaction:
        return 'Fee';
      case TransactionType.InterestTransaction:
        return 'Interest';
      default:
        return '';
    }
  }

  export function getIcon(type: TransactionType): string {
    switch (type) {
      case TransactionType.AchDomestic:
      case TransactionType.OriginatedACHTransaction:
      case TransactionType.ReceivedACHTransaction:
      case TransactionType.ReturnedACHTransaction:
      case TransactionType.ReturnedReceivedACHTransaction:
        return 'arrow_circle_right';
      case TransactionType.WireTransaction:
        return 'send';
      case TransactionType.CardReversalTransaction:
      case TransactionType.CardTransaction:
        return 'credit_card';
      default:
        return '';
    }
  }
}

export default TransactionType;
